<span class="modal-close-icon" xmlns="http://www.w3.org/1999/html"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="relayScriptRuleForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="officeId">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">
                  {{ office.city + ', ' + office.address }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="timePeriodId">Time Period</label>
              <select id="timePeriodId" class="form-control" formControlName="timePeriodId">
                <option *ngFor="let timePeriod of timePeriods" [value]="timePeriod.id">
                  {{ timePeriod.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="modifier">Modifier</label>
              <select id="modifier" class="form-control" formControlName="modifier">
                <option *ngFor="let modifier of modifiers" [value]="modifier">{{ modifier }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="relayBoardId">Relay Board</label>
              <select id="relayBoardId" class="form-control" formControlName="relayBoardId">
                <option></option>
                <option *ngFor="let relayBoard of relayBoards" [value]="relayBoard.id">
                  {{ relayBoard.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="sensorId">Sensor</label>
              <select id="sensorId" class="form-control" formControlName="sensorId">
                <option></option>
                <option *ngFor="let sensor of sensors" [value]="sensor.id">
                  {{ sensor.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <div class="form-check form-check-inline active-checkbox">
                <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
                <label class="form-check-label" for="isActive">Active</label>
              </div>
            </div>
          </div>
          <hr class="hr" />
          <div class="form-row" *ngIf="relayList.controls && relayList.controls.length > 0">
            <div class="col-md-12 mb-3">
              <h6>Relays</h6>
              <table class="table table-striped table-bordered">
                <thead>
                <tr>
                  <th>Board</th>
                  <th>Relay</th>
                  <th>Enabled</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let relay of relayList.controls; let i = index">
                  <td class="text-center">{{ relay.value.relayBoardName }}</td>
                  <td class="text-center">{{ relay.value.relayName }}</td>
                  <td class="text-center">{{ relay.value.isEnabled }}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-danger delete-button" (click)="removeRelay(i)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="relayBoardId1">Relay Board</label>
              <select id="relayBoardId1" class="form-control" formControlName="relayBoardId1">
                <option></option>
                <option *ngFor="let relayBoard of relayBoards" [value]="relayBoard.id">
                  {{ relayBoard.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3 mb-3">
              <label for="relayId">Relay</label>
              <select id="relayId" class="form-control" formControlName="relayId">
                <option></option>
                <option *ngFor="let relay of relays" [value]="relay.id">
                  {{ relay.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3 mb-3">
              <div class="form-check form-check-inline enabled-checkbox">
                <input class="form-check-input" type="checkbox" formControlName="isEnabled" id="isEnabled">
                <label class="form-check-label" for="isEnabled">Enabled</label>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label>&nbsp;</label>
              <button type="button" class="form-control btn btn-outline-secondary" (click)="addRelay()">Add Relay</button>
            </div>
          </div>
    <!--      <app-relay-script-add-relay [relayBoards]="relayBoards" [hidden]="isRelayFormHidden"></app-relay-script-add-relay>-->
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(relayScriptRuleForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>


